import { render } from "./EventForm.vue?vue&type=template&id=7743ba30&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=7743ba30&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7743ba30"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QIcon,QFile,QCheckbox,QBtn,QField});
